
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","stroke":"#FFBE1B","stroke-width":"2","stroke-miterlimit":"10","d":"M0 0h50v50H0z"}}),_c('g',{attrs:{"fill":"none","stroke":"#FFBE1B","stroke-width":"6","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M10 25h30M25 10v30"}})])])
          )
        }
      }
    